export {default} from "./Hero"


